// AUTO-GENERATED by scripts/generate_navbar.mjs — do not edit by hand.
// Regenerate: `npm run navbar` (also runs on predev/prebuild).
// Source of truth: src/pages/<section>/<slug>/variables.json
export const NAVBAR_FILE_LIST = [
  "cancers/ivermectin/variables.json",
  "cancers/methylene-blue/variables.json",
  "cancers/thiabendazole/variables.json",
  "cannabis/cannabis-sources/variables.json",
  "cannabis/medicinal-cannabis/variables.json",
  "cannabis/rick-simpson-oil/variables.json",
  "economics/glass-steagall/variables.json",
  "economics/tax-reform/variables.json",
  "education/educational/variables.json",
  "education/the-voynic-manuscript/variables.json",
  "insect-extinction/bee-extinction/variables.json",
  "insect-extinction/mosquito-extinction/variables.json",
  "insect-extinction/walmart-patents/variables.json",
  "mems/mems/variables.json",
  "mems/micro-fluidics/variables.json",
  "microwaves/emf-studies/variables.json",
  "microwaves/foia-microwave/variables.json",
  "problems-and-solutions/allocating-for-our-future/variables.json",
  "problems-and-solutions/avoiding-devistation/variables.json",
  "problems-and-solutions/diminishing-resources/variables.json",
  "problems-and-solutions/downsides-to-over-vaccination/variables.json",
  "problems-and-solutions/modern-beliefs-and-bad-practices/variables.json",
  "problems-and-solutions/nuclear-energy/variables.json",
  "problems-and-solutions/oil-and-gas-cure/variables.json",
  "problems-and-solutions/our-fiscal-policy-and-how-to-fix-it/variables.json",
  "problems-and-solutions/our-monopoly-on-monopoly-money/variables.json",
  "problems-and-solutions/our-skeletal-heritage/variables.json",
  "problems-and-solutions/panspermia/variables.json",
  "problems-and-solutions/patent-morality/variables.json",
  "problems-and-solutions/socialism-an-dthe-us/variables.json",
  "problems-and-solutions/solar-feasibility-outline/variables.json",
  "problems-and-solutions/tesla-and-goubau/variables.json",
  "problems-and-solutions/woordrow-wilsons-regret/variables.json",
  "quantum/quantum/variables.json",
  "sommerfeld-goubau/facebook/variables.json",
  "sommerfeld-goubau/google/variables.json",
  "sommerfeld-goubau/goubau-reality/variables.json",
  "sommerfeld-goubau/matlab/variables.json",
  "sommerfeld-goubau/military-tech/variables.json",
  "sommerfeld-goubau/patents/variables.json",
  "sommerfeld-goubau/sommerfeld-goubau/variables.json",
  "sommerfeld-goubau/wipow-comms/variables.json",
  "space/solaren/variables.json",
  "space/space-black-out/variables.json",
  "space/the-falacy-of-space-exploration/variables.json",
  "space/ufo-patents/variables.json",
  "space/ufos/variables.json",
  "space/wilson-disclosure/variables.json",
  "surface-waves/philips-and-boeing/variables.json",
  "surface-waves/surface-waves/variables.json",
  "surface-waves/visiv/variables.json",
  "tesla/fbi-vault/variables.json",
  "tesla/nikola-tesla/variables.json",
  "tesla/nikola-teslas-secret/variables.json",
  "tesla/patents/variables.json",
  "tesla/tesla-eq/variables.json",
  "tesla/tesla-leaks/variables.json",
  "tesla/teslas-flying-machine/variables.json",
  "tesla/the-strange-lifeof-nikola-tesla/variables.json",
  "tesla/timeline/variables.json",
  "test-page/test-page/variables.json",
  "virology/corona-virus/variables.json",
  "virology/microwaves/variables.json",
] as const;
